// extracted by mini-css-extract-plugin
export default {"container":"PageLoader__container-M3q_","contentHeight":"PageLoader__contentHeight-c7IS"};